/**
 * Keeps the cart drawer's 湊免運 row in sync with the cart.
 *
 * Quantity changes and removals go through cart-items-island-v2.js, which
 * patches line rows and the subtotal in place and never re-renders the rest of
 * the drawer — so the gap row kept showing the amount from when the drawer
 * first opened (e.g. 「再加 $479」 next to a $660 cart). On every cart change
 * this re-fetches the drawer section through the Section Rendering API and
 * swaps just the gap section in, out, or updates it.
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '.cart-flow__section--gap';
  var ANCHOR_SELECTOR = '.cart-flow__section--delivery';
  var FLOW_SELECTOR = '.cart-flow';
  var EVENTS = ['cart:updated', 'on:cart:change', 'cart:item-added', 'on:cart:add', 'on:line-item:change', 'cart-updated', 'cart:rerender-items'];

  var timer = null;
  var inflight = null;

  function drawerSectionId() {
    var drawer = document.getElementById('cart-drawer');
    var section = drawer && drawer.closest('.shopify-section');
    return section ? section.id.replace('shopify-section-', '') : null;
  }

  function apply(freshGap) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var current = drawer.querySelector(SECTION_SELECTOR);
    if (!freshGap) {
      if (current) current.remove();
      return;
    }
    if (current) {
      if (current.innerHTML !== freshGap.innerHTML) current.innerHTML = freshGap.innerHTML;
      current.hidden = false;
      applyAppState();
      return;
    }
    var flow = drawer.querySelector(FLOW_SELECTOR);
    if (!flow) return;
    var anchor = flow.querySelector(ANCHOR_SELECTOR);
    var node = freshGap.cloneNode(true);
    if (anchor && anchor.nextSibling) flow.insertBefore(node, anchor.nextSibling);
    else if (anchor) flow.appendChild(node);
    else flow.insertBefore(node, flow.firstChild);
    applyAppState();
  }

  function refresh() {
    var id = drawerSectionId();
    if (!id) return;
    if (inflight) inflight.abort();
    inflight = new AbortController();
    fetch('/?sections=' + encodeURIComponent(id), { signal: inflight.signal, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        if (!json || !json[id]) return;
        var doc = new DOMParser().parseFromString(json[id], 'text/html');
        apply(doc.querySelector(SECTION_SELECTOR));
      })
      .catch(function () { /* stale row is better than a broken drawer */ })
      .finally(function () { inflight = null; });
  }

  /**
   * The Vibe Delivery widget is the source of truth for the real rules
   * (product-specific free shipping, weight limits, brand limits). Once it has
   * resolved a rate for the chosen method, a cost of 0 means the order already
   * ships free — hide the row no matter what the thresholds say.
   */
  function applyAppState() {
    var drawer = document.getElementById('cart-drawer');
    var section = drawer && drawer.querySelector(SECTION_SELECTOR);
    if (!section) return;
    var st = null;
    try { st = window.VibeDelivery && window.VibeDelivery.getState && window.VibeDelivery.getState(); } catch (e) { st = null; }
    if (!st) return;
    var free = typeof st.lastShippingCost === 'number' && st.lastShippingCost === 0;
    section.hidden = !!free;
  }

  var stateTimers = [];
  function scheduleAppState() {
    stateTimers.forEach(clearTimeout);
    stateTimers = [800, 2500, 5000].map(function (ms) { return setTimeout(applyAppState, ms); });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { refresh(); scheduleAppState(); }, 450);
  }

  EVENTS.forEach(function (name) {
    document.addEventListener(name, schedule);
  });
  // Drawer open: the widget fetches a rate shortly after; re-check then too.
  document.addEventListener('on:cart-drawer:open', scheduleAppState);
  document.addEventListener('dispatch:cart-drawer:open', scheduleAppState);
  if (document.readyState === 'complete') scheduleAppState(); else window.addEventListener('load', scheduleAppState);
})();
